export const GET_CHALLENGE_REQUEST = 'ChallengePage/GET_CHALLENGE_REQUEST';
export const GET_CHALLENGE_SUCCESS = 'ChallengePage/GET_CHALLENGE_SUCCESS';
export const GET_CHALLENGE_FAILURE = 'ChallengePage/GET_CHALLENGE_FAILURE';
export const SET_CHALLENGE_RATING_REQUEST = 'ChallengePage/SET_CHALLENGE_RATING_REQUEST';
export const SET_CHALLENGE_RATING_SUCCESS = 'ChallengePage/SET_CHALLENGE_RATING_SUCCESS';
export const SET_CHALLENGE_RATING_FAILURE = 'ChallengePage/SET_CHALLENGE_RATING_FAILURE';
export const GET_TOURNAMENT_PLAYBACK_REQUEST = 'ChallengePage/GET_TOURNAMENT_PLAYBACK_REQUEST';
export const GET_TOURNAMENT_PLAYBACK_SUCCESS = 'ChallengePage/GET_TOURNAMENT_PLAYBACK_SUCCESS';
export const GET_TOURNAMENT_PLAYBACK_FAILURE = 'ChallengePage/GET_TOURNAMENT_PLAYBACK_FAILURE ';
export const RESET_STATE = 'ChallengePage/RESET_STATE';
